import { getUrlByType } from "utils/helper";
import { END_POINT } from "constants/apiConstant";
import { apiGet, apiPost } from "../utils/apiUtils";
const { GET_ACTIVE_DISTRIBUTOR_KEYS_API, GET_ACTIVE_DISTRIBUTOR_API, GET_TEST_MOUSER_API } =
  END_POINT;

export const getActiveDistributor = async () => {
  const response = await apiGet(END_POINT.GET_ACTIVE_DISTRIBUTOR_API);
  return response;
};

export const getActiveDistributorKeys = async () => {
  const response = await apiGet(END_POINT.GET_ACTIVE_DISTRIBUTOR_KEYS_API);
  return response;
};

export const getDistributorDataApi = async (API, keyword) => {
  const response = await apiPost(API, { keyword });
  return response;
};

export const getSearchDataApi = async ({ keyword, distributors }) => {
  const response = await apiPost(END_POINT.SEARCH_PARTNUMBER, { keyword, distributors });
  console.log("getSearchDataApi", { data: response });
  return response;
};

export const getSearchResponseApi = async ({ uniqueId }) => {
  const response = await apiGet(`${END_POINT.SEARCH_RESPONSE}/${uniqueId}`);
  console.log("getSearchResponseApi", { data: response });
  return response;
};

export const getTestDistributorsApi = async ({ type, keyword }) => {
  const response = await apiPost(getUrlByType(type), { keyword });
  console.log("getTestDistributorsApi", { data: response });
  return response;
};

// Validate the keys typed into the connect-distributor form, live, without
// saving them. `payload` carries the distributor field keys plus `type`.
export const testDistributorConnectionAPI = async (payload) => {
  const response = await apiPost(END_POINT.TEST_DISTRIBUTOR_CONNECTION, payload);
  return response;
};
